"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureCamelCase = ensureCamelCase;
exports.ensureSnakeCase = ensureSnakeCase;
const isObject = (value) => typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    !(value instanceof Date) &&
    !(value instanceof Map) &&
    !(value instanceof Set) &&
    !(value instanceof Error) &&
    !(value instanceof RegExp);
const isValidInput = (value) => value !== null && value !== undefined;
const convertToCamelCase = (str) => {
    // Preserve leading underscores
    const matches = str.match(/^(_+)/);
    const leadingUnderscores = matches ? matches[1] : "";
    const withoutLeadingUnderscores = str.slice(leadingUnderscores.length);
    if (!withoutLeadingUnderscores) {
        return str;
    }
    // Split by underscore and capitalize
    const converted = withoutLeadingUnderscores
        .split("_")
        .map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
        .join("");
    return leadingUnderscores + converted;
};
const convertToSnakeCase = (str) => {
    // Preserve leading underscores
    const matches = str.match(/^(_+)/);
    const leadingUnderscores = matches ? matches[1] : "";
    const withoutLeadingUnderscores = str.slice(leadingUnderscores.length);
    if (!withoutLeadingUnderscores) {
        return str;
    }
    // Handle acronyms and regular camelCase
    const withAcronyms = withoutLeadingUnderscores
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
        .replace(/([a-z\d])([A-Z])/g, "$1_$2")
        .toLowerCase();
    return leadingUnderscores + withAcronyms;
};
function ensureCamelCase(input) {
    if (!isValidInput(input)) {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map((item) => ensureCamelCase(item));
    }
    if (!isObject(input)) {
        return input;
    }
    try {
        const result = {};
        // Handle all properties including symbols
        const allKeys = [
            ...Object.getOwnPropertyNames(input),
            ...Object.getOwnPropertySymbols(input),
        ];
        for (const key of allKeys) {
            const descriptor = Object.getOwnPropertyDescriptor(input, key);
            if (typeof key === "symbol") {
                Object.defineProperty(result, key, descriptor);
            }
            else {
                const newKey = convertToCamelCase(key.toString());
                const value = input[key];
                if (isObject(value)) {
                    // Transform nested object and preserve its symbol properties
                    const transformed = ensureCamelCase(value);
                    result[newKey] = transformed;
                    // Copy all symbol properties from the original nested object
                    Object.getOwnPropertySymbols(value).forEach((symKey) => {
                        const symDesc = Object.getOwnPropertyDescriptor(value, symKey);
                        Object.defineProperty(transformed, symKey, symDesc);
                    });
                }
                else if (Array.isArray(value)) {
                    result[newKey] = value.map((item) => ensureCamelCase(item));
                }
                else {
                    result[newKey] = value;
                }
            }
        }
        return result;
    }
    catch (error) {
        throw new Error(`Failed to transform to camelCase: ${error instanceof Error ? error.message : "Unknown error"}`);
    }
}
function ensureSnakeCase(input) {
    if (!isValidInput(input)) {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map((item) => ensureSnakeCase(item));
    }
    if (!isObject(input)) {
        return input;
    }
    try {
        const result = {};
        const descriptors = Object.getOwnPropertyDescriptors(input);
        for (const key of [
            ...Object.getOwnPropertyNames(input),
            ...Object.getOwnPropertySymbols(input),
        ]) {
            const desc = descriptors[key];
            const { value } = desc;
            if (typeof key === "symbol") {
                if (isObject(value)) {
                    const transformed = ensureSnakeCase(value);
                    Object.defineProperty(result, key, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: transformed,
                    });
                }
                else {
                    result[key] = value;
                }
            }
            else {
                const newKey = convertToSnakeCase(key.toString());
                if (isObject(value)) {
                    const transformed = ensureSnakeCase(value);
                    result[newKey] = transformed;
                    // Copy symbol properties
                    Object.getOwnPropertySymbols(value).forEach((symKey) => {
                        Object.defineProperty(transformed, symKey, Object.assign(Object.assign({}, Object.getOwnPropertyDescriptor(value, symKey)), { value: value[symKey] }));
                    });
                }
                else if (Array.isArray(value)) {
                    result[newKey] = value.map((item) => ensureSnakeCase(item));
                }
                else {
                    result[newKey] = value;
                }
            }
        }
        return result;
    }
    catch (error) {
        throw new Error(`Failed to transform to snake_case: ${error instanceof Error ? error.message : "Unknown error"}`);
    }
}
//# sourceMappingURL=typeTransformer.js.map